import { render, staticRenderFns } from "./SourceFiles.vue?vue&type=template&id=3e66e061"
import script from "./SourceFiles.vue?vue&type=script&lang=ts"
export * from "./SourceFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports